// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2rmfI","addWidgetButton":"Header_addWidgetButton__2yNRs","dashboardTabs":"Header_dashboardTabs__1oSdW","active":"Header_active__b9_oj"};